export function deleteCorp(data) {
    let { deleteCorpRequest, deleteCorpError, deleteCorpResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/corp/delete',
        this.createBundle('app/corp/delete', { corp: data }, this.POST, deleteCorpRequest, deleteCorpResult, deleteCorpError)
    )
}
